import t from "../../../i18n";
import formatDate from "@ui/i18n/formatDate";

interface Analysis {
  group: string | null;
  label: string | null;
  date: number | Date | string;
}

interface AnalysisNoDate {
  group: string | null;
  label: string | null;
}

export const analysisDate = (date: number | Date | string, timeZone: string | null) =>
  formatDate(date, "datetime", timeZone);

// juste the cycle/test part, for when date is displayed anyway, for example in tooltips
// CHECK FOR NULLS FIRST
export const analysisTitleNoDate = ({ group, label }: AnalysisNoDate) => {
  if (group && group !== "CYCLE" && label && label !== "TEST LABEL")
    return t("commons.analysis_title.group_and_label", {
      group,
      label,
    });

  if (group && group !== "CYCLE")
    return t("commons.analysis_title.group", {
      group,
    });

  if (label && label !== "TEST LABEL")
    return t("commons.analysis_title.label", {
      label,
    });

  return null;
};

export const analysisDateIncludedInTitleShort = ({ label }: { label: string | null }) => !label;

// date at the end only if necessary (no value for test)
export const analysisTitleShort = ({ group, label, date }: Analysis, timeZone: string) => {
  if (group && label && group !== "CYCLE" && label !== "TEST LABEL")
    return t("commons.analysis_title.group_and_label", {
      group,
      label,
    });

  if (group && group !== "CYCLE")
    return t("commons.analysis_title.group_and_date", {
      group,
      date: analysisDate(date, timeZone),
    });

  if (label && label !== "TEST LABEL")
    return t("commons.analysis_title.label", {
      label,
    });

  return analysisDate(date, timeZone);
};

// date at the end, maximum informations
export const analysisTitleLong = ({ group, label, date }: Analysis, timeZone: string | null) => {
  if (group && group !== "CYCLE" && label && label !== "TEST LABEL")
    return t("commons.analysis_title.group_and_label_and_date", {
      date: analysisDate(date, timeZone),
      group,
      label,
    });

  if (group && group !== "CYCLE")
    return t("commons.analysis_title.group_and_date", {
      group,
      date: analysisDate(date, timeZone),
    });

  if (label && label !== "TEST LABEL")
    return t("commons.analysis_title.test_and_date", {
      label,
      date: analysisDate(date, timeZone),
    });

  return analysisDate(date, timeZone);
};
